<template>
  <router-view />
</template>

<script>
export default {
  name: 'AdministrativePropertiesIndex'
}
</script>
